import { createServerFn } from "@tanstack/react-start";
import { optionalAuth } from "./auth.server";
import { daysUntilReset, FREE_GENERATION_LIMIT, resolveUsageCount } from "./usage";

export const getUsage = createServerFn({ method: "GET" }).handler(async () => {
  const auth = await optionalAuth();
  if (!auth) return null;

  const { getSupabaseAdmin } = await import("@/integrations/supabase/admin.server");
  const admin = getSupabaseAdmin();
  const { data: profile } = await admin
    .from("profiles")
    .select("plan, docs_used_this_month, usage_reset_date")
    .eq("id", auth.user.id)
    .maybeSingle();

  if (!profile) return null;

  const { used, resetAt, plan } = await resolveUsageCount(admin, auth.user.id, profile);

  return {
    plan,
    used,
    limit: plan === "pro" ? null : FREE_GENERATION_LIMIT,
    resetAt: resetAt.toISOString(),
    daysUntilReset: plan === "pro" ? null : daysUntilReset(resetAt),
  };
});
